import { render } from "./PriceTrendChart.vue?vue&type=template&id=21505ab4&scoped=true"
import script from "./PriceTrendChart.vue?vue&type=script&lang=js"
export * from "./PriceTrendChart.vue?vue&type=script&lang=js"

import "./PriceTrendChart.vue?vue&type=style&index=0&id=21505ab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21505ab4"]])

export default __exports__